module.exports = __webpack_public_path__ + "img/BE.a3d5b658.svg";